import React, { useState } from "react";
import classNames from "classnames";
import { Card } from "react-bootstrap";
import { RouteComponentProps, useHistory } from "react-router";
import AccessTokenSessionService from "go-security/services/accessTokenSessionService";
import { apiOrganization } from "../../../../../../../../services/Api/Organization/apiOrganization";
import {
	ApplicationApi,
	ApplicationProvider,
	ApplicationTemplateApi,
} from "../../../../../../../../services/Api/Organization/types";
import AppCardInstalled from "./AppCardInstalled";
import AppCardUninstalled from "./AppCardUninstalled";
import AppModal from "./AppModal/AppModal";
import InstallationAppForm from "./InstallationAppForm";

interface Props {
	configApp: ApplicationTemplateApi;
	installedApp?: ApplicationApi;
	routeProps?: RouteComponentProps;
	handleUninstall?: (app: ApplicationApi) => void;
	handleUpdate?: (app: ApplicationApi) => void;
	handleUpdateNewInstalledApp?: (app: ApplicationApi) => void;
}

const AppCard = ({
	configApp,
	installedApp,
	routeProps,
	handleUpdate,
	handleUninstall,
	handleUpdateNewInstalledApp,
}: Props): JSX.Element => {
	const [showModal, setShowModal] = useState(false);
	const history = useHistory();
	const [appConfigForInstallationModal, setAppConfigForInstallationModal] = useState<
		ApplicationTemplateApi | undefined
	>();

	const handleInstall = async () => {
		const accessToken = AccessTokenSessionService.get();

		switch (configApp.provider) {
			case ApplicationProvider.LOCATIONS:
			case ApplicationProvider.GOHOTELINTEGRATION:
			case ApplicationProvider.MEWS:
			case ApplicationProvider.HOTELLION:
			case ApplicationProvider.INFOR_STARLIGHT:
			case ApplicationProvider.HOLIDAY_PMS:
			case ApplicationProvider.HOTELGRAM:
			case ApplicationProvider.HOTRES:
			case ApplicationProvider.CHART:
			case ApplicationProvider.M_HOTEL:
			case ApplicationProvider.NFHOTEL:
			case ApplicationProvider.KWHOTEL:
			case ApplicationProvider.WOLT_DRIVE:
			case ApplicationProvider.BETASI:
			case ApplicationProvider.BETASI_V2:
				setAppConfigForInstallationModal(configApp);
				break;
			case ApplicationProvider.CALL_RECORDER: {
				const res = await apiOrganization.installApplicationPost(
					configApp.provider,
					accessToken ? accessToken : ""
				);
				handleUpdateNewInstalledApp && handleUpdateNewInstalledApp(res);
				break;
			}
			default:
				apiOrganization.installApplication(configApp.provider, accessToken ? accessToken : "");
		}
	};

	const handleCardClick = () => {
		installedApp ? history.push(`${routeProps?.match.url}/${installedApp.id}`) : setShowModal(true);
	};

	const handleOnHideAppModal = () => {
		setShowModal(false);
		setAppConfigForInstallationModal(undefined);
	};

	return (
		<div className={"col-md-4 mb-3"}>
			{showModal && (
				<AppModal
					configApp={configApp}
					key={showModal ? "modal-on" : "modal-off"}
					handleUpdate={handleUpdate}
					installedApp={installedApp}
					handleUninstall={handleUninstall}
					handleUpdateNewInstalledApp={handleUpdateNewInstalledApp}
					onHide={handleOnHideAppModal}
					setShowParentModal={setShowModal}
				/>
			)}
			{appConfigForInstallationModal && (
				<InstallationAppForm
					show={!!appConfigForInstallationModal}
					onHide={() => {
						setAppConfigForInstallationModal(undefined);
						setShowModal(false);
					}}
					appConfig={appConfigForInstallationModal}
				/>
			)}
			<Card className={classNames("h-100", { "card-hover": true })} onClick={handleCardClick}>
				<Card.Body>
					{installedApp ? (
						<AppCardInstalled
							handleUninstall={handleUninstall}
							routeProps={routeProps}
							installedApp={installedApp}
							configApp={configApp}
							handleUpdate={handleUpdate}
						/>
					) : (
						<AppCardUninstalled configApp={configApp} onInstall={handleInstall} />
					)}
				</Card.Body>
			</Card>
		</div>
	);
};
export default AppCard;
